import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from "react";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropInfoAuthorSection } from "./SingleWaveDropInfoAuthorSection";
import WaveDropTime from "../drops/time/WaveDropTime";
import { SingleWaveDropPosition } from "./SingleWaveDropPosition";
import { WinnerBadge } from "./WinnerBadge";
interface WaveDropMetaRowProps {
  readonly drop: ExtendedDrop;
  readonly isWinner: boolean;
  readonly children?: ReactNode | undefined;
}
export const WaveDropMetaRow = t0 => {
  const $ = _c(17);
  const {
    drop,
    isWinner,
    children
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = <SingleWaveDropInfoAuthorSection drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-text-white/40">{"\xB7"}</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== drop.created_at) {
    t3 = <WaveDropTime timestamp={drop.created_at} size="sm" />;
    $[3] = drop.created_at;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop || $[6] !== isWinner) {
    t4 = isWinner && <><span className="tw-text-white/40">{"\xB7"}</span><WinnerBadge drop={drop} variant="simple" /></>;
    $[5] = drop;
    $[6] = isWinner;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== drop || $[9] !== isWinner) {
    t5 = !isWinner && drop?.drop_type === ApiDropType.Participatory && <><span className="tw-text-white/40">{"\xB7"}</span><SingleWaveDropPosition rank={drop.rank} drop={drop} variant="simple" /></>;
    $[8] = drop;
    $[9] = isWinner;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== t1 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-3 tw-flex-wrap">{t1}{t2}{t3}{t4}{t5}{children}</div>;
    $[11] = children;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};